import React, { useEffect, useState } from 'react';
import { mobilizeiInvoicesService } from '../_services/mobilizei/invoices.service';
import MainLayout from '../_layouts/main';
import { CircularProgress, Container, Grid, Typography } from '@material-ui/core';
import Header from './Header';
import CustomerData from './CustomerData';
import BillingDetails from './BillingDetails';
import PaymentMethods from './PaymentMethods';
import { useHistory, useParams } from 'react-router';
import _ from 'lodash';

export default function InvoicePage() {
    const { invoiceId } = useParams();
    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [invoice, setInvoice] = useState({});

    useEffect(() => {
        if(!invoiceId) {
            history.push('/');
            return;
        }

        mobilizeiInvoicesService.getInvoiceById(invoiceId)
            .then(invoiceData => {
                setInvoice(invoiceData);
                setLoading(false);
            })
            .catch(e => {
                setInvoice({});
                setLoading(false);
            })
    }, []);

    return (
        <MainLayout>
            <Container maxWidth="sm">
                {loading ? (
                    <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                        style={{ minHeight: '60vh' }}
                    >
                        <Grid item xs={4}>
                            <CircularProgress color="primary" />
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        {_.isEmpty(invoice) ? (
                            <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justify="center"
                                style={{ minHeight: '60vh' }}
                            >
                                <Grid item xs={12}>
                                    <Typography align="center" variant="h4">
                                        Fatura inexistente
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <>
                                <Header invoice={invoice} />
                                <CustomerData invoice={invoice} />
                                <BillingDetails invoice={invoice} />
                                {invoice.status === 'pending' && <PaymentMethods invoice={invoice} setInvoice={setInvoice} />}
                            </>
                        )}
                    </>
                )}
            </Container>
        </MainLayout >
    );
}